import classNames from 'classnames';
import React, { ButtonHTMLAttributes } from 'react';

/**
 * What a button does, shown by its look: one filled DeepHealth plum per screen for the main action, neutral
 * outlines for the others, red for what stops or throws away, amber for what holds or resets. Green is kept
 * for success states, never for an action: `go` is the main action's look, `go-outline` a secondary one.
 */
export type ButtonTone =
  | 'neutral'
  | 'primary'
  | 'go'
  | 'go-outline'
  | 'stop'
  | 'caution';

const PRIMARY =
  'border-dl-primary bg-dl-primary font-semibold text-white hover:border-dl-primary-hover hover:bg-dl-primary-hover';
const OUTLINE =
  'border-dl-border bg-dl-surface font-medium text-dl-text hover:border-dl-strong hover:bg-dl-raised';

export const BUTTON_TONES: Record<ButtonTone, string> = {
  neutral: OUTLINE,
  primary: PRIMARY,
  go: PRIMARY,
  'go-outline': OUTLINE,
  stop: 'border-dl-danger bg-dl-danger font-semibold text-white hover:opacity-90',
  caution:
    'border-dl-warning/50 bg-dl-surface font-medium text-dl-warning hover:bg-dl-warning-tint',
};

export function PageButton({
  className,
  tone = 'neutral',
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { tone?: ButtonTone }) {
  return (
    <button
      className={classNames(
        'mx-1 cursor-pointer rounded-lg border px-4 py-1.5 transition disabled:cursor-auto disabled:border-dl-border disabled:bg-dl-sunken disabled:text-dl-faint',
        BUTTON_TONES[tone],
        className
      )}
      {...props}
    />
  );
}
